import React from 'react';
import ReactDOM from 'react-dom/client';

// Design tokens — must load before any component CSS
import './theme.css';
import './index.css';

// Fonts
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/cormorant-garamond/700.css';

import 'react-loading-skeleton/dist/skeleton.css';

import App from './App';
import { APP } from './app/appConfig';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { SkeletonTheme } from 'react-loading-skeleton';
import { AudioPlayerProvider } from './audio/AudioPlayerProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SkeletonTheme baseColor={APP.skeleton.baseColor} highlightColor={APP.skeleton.highlightColor} duration={1.6}>
        <AudioPlayerProvider>
          <App />
        </AudioPlayerProvider>
      </SkeletonTheme>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
